import instance from '../instance';
import getLiveElement from './get-live-element';

const getParentLiveElement = (childId) => {
  const childElement = getLiveElement(childId);
  if (!childElement) return null;

  const parentId = instance.driver.referenceMap.getParentReferenceId(childElement);
  if (!parentId) return null;

  return getLiveElement(parentId);
};

export default getParentLiveElement;
